import React from "react";

export const renderValue = (value) => (
  <strong style={{ float: "right" }}>{value || "NA"}</strong>
);
